import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
export function Guarantee() {
  return <section className="bg-mist px-4 py-16 sm:py-24" data-id="element-190" data-mp="20m4opq90saty">
      <div className="mx-auto max-w-3xl rounded-3xl bg-white p-6 text-center sm:p-12" data-id="element-191" data-mp="24money98rmi7">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-navy text-white" data-id="element-192" data-mp="29doj606mjyj4">
          <ShieldCheckIcon className="h-8 w-8 text-cta" aria-hidden="true" data-id="element-193" data-mp="2edt1lvr3f3bz" />
          <span className="mt-1 font-display text-sm font-black uppercase leading-none" data-id="element-194" data-mp="2jc4ekfcoptyf">7 days</span>
        </div>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-[#1474D4] sm:text-sm" data-id="element-195" data-mp="2oao04end93q9">Your purchase protection</p>
        <h2 className="text-balance mt-3 font-display text-[30px] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-196" data-mp="2sbhnn6wwcgim">
          Explore the Blueprint With Confidence
        </h2>
        <div className="mt-5 space-y-4 text-base leading-relaxed text-navy/75 sm:text-lg" data-id="element-197" data-mp="xzt2gn02nhps">
          <p data-id="element-198" data-mp="3sloqljxoh2fe">
            I want you to feel comfortable reviewing the material and deciding whether it meets your professional
            learning needs.
          </p>
          <p className="font-semibold text-navy" data-id="element-199" data-mp="3ivn1cotl9dyw">
            You have seven days after purchase to review your digital library. If the material doesn’t meet your
            expectations, contact our support team within that period to request a refund.
          </p>
          <p data-id="element-200" data-mp="fe50x2g5b98i">The objective is to give you a practical educational resource you can explore with confidence.</p>
        </div>
      </div>
      <SectionCTA tone="light" label="Try it risk-free for 7 days" data-id="element-201" data-mp="5ggxlo4h4teq" />
    </section>;
}